import React from 'react';
import { useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {ExpandMoreOutlined} from '@material-ui/icons';
import * as loggingUtils from './utils/loggingUtils';
import * as encryptUtils from "./encryptDecryptUtils";
import './NounsAccordion.css';


function NounsAccordion(props) {
  const [current, setCurrent] = useState(-1);

  const changeState = (panel) => (e, newValue) => {
    setCurrent(newValue ? panel : -1);
  }

  return (
    <div>
      <Accordion expanded = {current === 0} onChange = {changeState(0)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              What kind of file type can I upload?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          We currently only support JPEG and PNG, however, we plan on adding more file types soon
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 1} onChange = {changeState(1)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              What fields do I need to fill out?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          You need to fill out every input in the upload form in order to have a successful upload
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 2} onChange = {changeState(2)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              What does the collection name mean?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        The collection name Is what the collection is called and each item in the collection will have a corresponding ID
        For example, If your Collection Name was Noun, It would be Noun 1, Noun 2, etc.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 3} onChange = {changeState(3)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              What is a reserve price?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          The reserve price is the least amount someone can bid for your item
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 4} onChange = {changeState(4)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div >
              What is the auction duration?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        The auction duration is how long each auction will run for
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 5} onChange = {changeState(5)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
        <div className = "flex items-center">
          <div>
          How many files can I upload?
          </div>
        </div>
        </AccordionSummary>
        <AccordionDetails>
          You can upload as many as you'd like depending on how long you would like your auction to run. We recommend keeping it under 90 images.
          The more files you upload the longer it will take to upload so be patient
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 6} onChange = {changeState(6)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
        <div className = "flex items-center">
          <div>
          How many transactions do I need to sign and how do I start the first auction?
          </div>
        </div>
        </AccordionSummary>
        <AccordionDetails>
        You need to sign 2 transactions when you upload and a 3rd to start the auction. The first transaction allows you to deploy your own nouns token contract and the second is to initalize the collection on the auction house.
        Once the upload is complete you will be redirected to a new page where you will start the first auction.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 7} onChange = {changeState(7)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
            How do creators make money?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          The creator makes money from every NFT auction. We take 5% of inital primary sale.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 8} onChange = {changeState(8)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
            Are these contracts creator owned?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          Yes
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 9} onChange = {changeState(9)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
            Are the contracts audited?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className="flex flex-col">
          <div>
            This is a Nouns fork with some modifications. The source code is published <a href="https://etherscan.io/address/0x7f7c0a157d05cffa4eb825d4bfe2dded41ed5c10#code" className="text-blue-400"> here. </a> If you do not feel comfortable uploading please do not
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}


export default NounsAccordion;
